export const filterAndSortProducts = (
  products,
  priceRange,
  selectedCategories,
  selectedColors,
  onSale,
  inStock
) => {
  let filteredProducts = products;

  // Filter by price range
  filteredProducts = filteredProducts.filter(
    (product) =>
      product.price >= priceRange[0] && product.price <= priceRange[1]
  );

  // Filter by categories
  if (selectedCategories.length > 0) {
    filteredProducts = filteredProducts.filter((product) =>
      selectedCategories.includes(product.category)
    );
  }

  // Filter by Selected Colors
  if (selectedColors.length > 0) {
    filteredProducts = filteredProducts.filter((product) =>
      selectedColors.includes(product.color)
    );
  }

  // Filter by "On Sale"
  if (onSale) {
    filteredProducts = filteredProducts.filter((product) =>
      product.badgeTitle.includes('%')
    );
  }

  // Filter by "In Stock"
  if (inStock) {
    filteredProducts = filteredProducts.filter((product) => product.inStock);
  }

  return filteredProducts;
};
